/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import * as XLSX from 'xlsx';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Tabs,
  Checkbox,
  message,
  notification,
  DatePicker,
  Menu,
  Modal,
  Progress,
  TreeSelect,
  Tag,
  Select as AntSelect,
} from 'antd';
import {
  FileExcelOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import API from 'utils/api';
import currencyFormatter from 'utils/currencyFormatter';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
// import HTTP, { baseURL } from 'utils/api';
import { onAlert, onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import Dragger from 'components/Dragger';
import {
  DESCUENTO_RECURRENTE_Y_FIJO,
  DESCUENTO_RECURRENTE_Y_VARIABLE,
  DESCUENTO_TEMPORAL,
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
  agrupadorDescuentos,
} from 'utils/constants';
import {
  getEstadosGlobales,
  getAreas,
  getCuentasContables,
} from 'api/catalogos/index';
import {
  getDescuentos,
  postDescuento,
  deleteDescuento,
  patchDescuento,
  getDescuento,
  getDescuentosOptimized,
  exportarDescuentosEmpleadosExcel,
} from 'api/nominas/descuentos/descuentos';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import {
  getAdministracionDePlazas,
  getAdministracionDePlazasvistaOptimized,
} from 'api/catalogos/admnistracionDePlazas';
import { getEmpleado, getEmpleadosConDatosOpFilteredPaginated, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getBecarioVistaoptimizado } from 'api/catalogos/Becario';
import { getHonorarioAsimiladoVistaoptimizado } from 'api/catalogos/HonorarioAsimilado';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuesto, getPuestos } from 'api/catalogos/puestos';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
  NOMBRES_PATTERN,
} from 'utils/patterns';
import moment from 'moment';
import TipoDescuento from 'components/Nominas/Descuentos/TipoDescuento';
import DescuentoSuspencion from 'components/Nominas/Descuentos/Suspencion';
import DatosInformativos from 'components/Nominas/Descuentos/DatosInformativos';
import { getModelPermission } from 'utils/permission';
import BeneficiariosExternos, { beneficiariosExternosPermission } from 'components/Nominas/Descuentos/BeneficiariosExternos';
import { getTiposDescuentos } from 'api/nominas/descuentos/tiposDescuentos';
import { getDatoOperacionalesDeEmpleados, getDatoOperacionalPorEmpleado } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getDatoOperacionalPorBecario } from 'api/estructuraOrganizacional/datosOperacionalesDeBecario';
import { getDatoOperacionalPorHonorarioAsimilado } from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';

import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CustomSearch from 'components/customSearch';
import Adjuntos from 'components/Nominas/Descuentos/Adjuntos';
import CRUDgeneric from 'utils/CRUDgeneric';
import ReporteRecurrenteModal, { FORMATO_MONEDA } from 'components/ReporteRecurrenteModal';

const { TabPane } = Tabs;
// `todos: null` -> no se envía `estados_globales` y la vista optimizada regresa los
// descuentos de todos los estatus (solo filtra por los parámetros que recibe).
const TAB_ESTADOS_DESCUENTOS = {
  todos: null, activas: 1, autorizadas: 4, canceladas: 5, suspendidos: 7,
};
const DESCRIPCION_PROCESO_CAMBIO_ESTADOS = 'Cambiar Estado Descuento Empleado';
const baseURI = 'nominas/descuentos-empleados-importar-excel';
const DESCRIPCION_PROCESO_IMPORTAR = 'Importar Descuentos Empleados';

const SUJETO_EMPLEADO = 'empleado';
const SUJETO_BECARIO = 'becario';
const SUJETO_HONORARIO_ASIMILADO = 'honorarioasimilado';
const SUJETO_OPCIONES = [
  { slug: SUJETO_EMPLEADO, etiqueta: 'Empleado' },
  { slug: SUJETO_BECARIO, etiqueta: 'Becario' },
  { slug: SUJETO_HONORARIO_ASIMILADO, etiqueta: 'Honorario Asimilado' },
];
const SUJETO_FK = {
  [SUJETO_EMPLEADO]: 'empleado',
  [SUJETO_BECARIO]: 'becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado',
};
const SUJETO_LABEL_PERSONA = {
  [SUJETO_EMPLEADO]: 'No. y Nombre del Empleado',
  [SUJETO_BECARIO]: 'No. y Nombre del Becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'No. y Nombre del Honorario Asimilado',
};
const SUJETO_ETIQUETA = {
  [SUJETO_EMPLEADO]: 'Empleado',
  [SUJETO_BECARIO]: 'Becario',
  [SUJETO_HONORARIO_ASIMILADO]: 'Honorario Asimilado',
};
const SUJETO_LABEL_PROP = {
  [SUJETO_EMPLEADO]: 'numero_y_nombre_completo',
  [SUJETO_BECARIO]: 'becario_numero_y_nombre_completo',
  [SUJETO_HONORARIO_ASIMILADO]: 'honorario_asimilado_numero_y_nombre_completo',
};
const GET_PERSONAS_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getEmpleadosOptimized,
  [SUJETO_BECARIO]: getBecarioVistaoptimizado,
  [SUJETO_HONORARIO_ASIMILADO]: getHonorarioAsimiladoVistaoptimizado,
};
const GET_DATO_OP_POR_SUJETO = {
  [SUJETO_EMPLEADO]: getDatoOperacionalPorEmpleado,
  [SUJETO_BECARIO]: getDatoOperacionalPorBecario,
  [SUJETO_HONORARIO_ASIMILADO]: getDatoOperacionalPorHonorarioAsimilado,
};

export const descuentosPermission = {
  permissionModel: 'descuento',
  catalogsModels: [],
  tabsModels: [],
};

const Descuento = ({ permission }) => {
  const [form] = Form.useForm();
  const [formExtra] = Form.useForm();
  const [formCarga] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('descuento');
  const [mutable, setMutable] = useState(true);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  // Total de Descuentos de Empleados que coinciden con el tab/sujeto/búsqueda actual
  // (paginado en servidor) -- alimenta `count` del componente Table para que la
  // paginación muestre el total real sin tener cargadas todas las filas en memoria.
  const [totalCount, setTotalCount] = useState(0);
  const [estados, setEstados] = useState([]);
  // const [areas, setAreas] = useState();
  const [empleados, setEmpleados] = useState([]);
  const [plazas, setPlazas] = useState();
  const [plaza, setPlaza] = useState();
  const [area, setArea] = useState();
  // const [puestos, setPuestos] = useState();
  const [puesto, setPuesto] = useState();
  // const [adminPlazas, setAdminPlazas] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [showReporteDescuentos, setShowReporteDescuentos] = useState(false);
  const [selectedTipoDescuento, setSelectedTipoDescuento] = useState();
  const [periodosDetalles, setPeriodosDetalles] = useState([]);
  const [suspencionDefinitiva, setSuspencionDefinitiva] = useState();
  const [suspencionTemporal, setSuspencionTemporal] = useState();
  const [importeDescuento, setImporteDescuento] = useState(0);
  const [tiposDescuentos, setTiposDescuentos] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [periodo, setPeriodo] = useState();
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isPollingImport, setIsPollingImport] = useState(false);
  const [progresoImport, setProgresoImport] = useState({ en_curso: 0, total: 0 });
  const pollingImportRef = useRef(null);
  const [isPollingCambioEstados, setIsPollingCambioEstados] = useState(false);
  const [progresoCambioEstados, setProgresoCambioEstados] = useState({ en_curso: 0, total: 0 });
  const pollingCambioEstadosRef = useRef(null);
  const [visibleAuthorize, setVisibleAuthorize] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleReactivar, setVisibleReactivar] = useState(false);

  const [selectedData, setSelectedData] = useState([]);
  const [isAutorizado, setIsAutorizado] = useState(false);
  const [isInactivo, setIsInactivo] = useState(false);
  const [isCancelado, setIsCancelado] = useState(false);
  const [estadoActualRegistro, setEstadoActualRegistro] = useState();
  const [visibleInactivo, setVisibleInactivo] = useState(false);
  const [selectedDescuento, setSelectedDescuento] = useState();
  const [descuentoEmpleadoAutorizado, setDescuentoEmpleadoAutorizado] = useState(false);
  const [descuentoEmpleadoInactivo, setDescuentoEmpleadoInactivo] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [nominaDisplay, setNominaDisplay] = useState();
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [openSearch, setVisibleSearch] = useState(false);
  // const [dataSearch, setDataSearch] = useState([]);
  // const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  // const [pageActual, setPageActual] = useState(1);
  // const [periodosDetallesFiltered, setPeriodosDetallesFiltered] = useState([]);
  const [tipoNominaEmpleadoInfo, setTipoNominaEmpleadoInfo] = useState();
  const [cuentasContables, setCuentasContables] = useState([]);
  // La pantalla abre en "Todos" (primer tab).
  const [tabListaActiva, setTabListaActiva] = useState('todos');
  const [currentTableData, setCurrentTableData] = useState([]);
  const [sujetoActivo, setSujetoActivo] = useState(SUJETO_EMPLEADO);
  const [personasDataSource, setPersonasDataSource] = useState([]);

  // let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const getPermission = getModelPermission(
    beneficiariosExternosPermission.permissionModel,
    beneficiariosExternosPermission.catalogsModels,
    beneficiariosExternosPermission.tabsModels,
    false,
  );

  const mapToTreeData = (nodes) => nodes.map((node) => {
    const isLeaf = !node.children || node.children.length === 0;

    return {
      title: `${node.clave_visible || node.clave} - ${node.nombre}`,
      value: node.id,
      key: node.id,
      disabled: !isLeaf, //  Deshabilita si no es hoja
      children: node.children ? mapToTreeData(node.children) : undefined,
    };
  });
  const removeEmptyChildren = (node) => {
    if (!node.children || node.children.length === 0) {
      return { ...node, children: undefined };
    }

    return {
      ...node,
      children: node.children.map(removeEmptyChildren),
    };
  };
  const normalize = (_data) => {
    const nodeMap = new Map();

    _data.forEach((node) => {
      nodeMap.set(node.id, {
        ...node,
        children: [],
        key: `${node.id}`, // clave única para antd Table
      });
    });
    const roots = [];
    _data.forEach((node) => {
      const currentNode = nodeMap.get(node.id);
      if (node.cuenta_padre) {
        const parent = nodeMap.get(node.cuenta_padre);
        if (parent) {
          parent.children.push(currentNode);
        }
      } else {
        roots.push(currentNode);
      }
    });

    return roots.map(removeEmptyChildren);
  };

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        empleado_nombre: e?.empleado,
        empleado_puesto: e?.empleado,
        empleado_area: e?.empleado,
        empleado_nPlaza: e?.empleado,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const basicKeys = [
    'descuento',
    'datos',
    'beneficiarios',
    'suspencion',
    'adjuntos',
  ];

  const complexForms = [];

  const formInstances = [
    form,
  ];
  // Recibe la key del tab (no el estado) para que "Todos" (estado null) no caiga en el
  // estado del tab anterior.
  // Paginado en servidor (ver getDescuentosEmpleadosVistaOptimized): antes traía TODOS
  // los Descuentos de Empleados de la entidad en una sola respuesta (~106 MB de JSON
  // medidos en Tlajomulco con ~80,000 filas) y la paginación la hacía AntD en memoria
  // sobre ese arreglo completo -- de ahí que la pantalla se sintiera cada vez más lenta
  // según crecían las cargas externas de descuentos. `data` ahora solo contiene la
  // página actual (10 filas, igual que el resto del proyecto); `totalCount` alimenta el
  // total que muestra la paginación. La selección se limpia en cada llamada (cambio de
  // página, de tab, de sujeto o de búsqueda) para que "seleccionar todos" del checkbox
  // de encabezado siempre corresponda a la página visible, nunca a páginas anteriores.
  const fetchData = async (page = 1, q = null, tabKey = tabListaActiva, sujeto = sujetoActivo) => {
    setLoading(true);
    const estadosGlobales = TAB_ESTADOS_DESCUENTOS[tabKey];
    const _data = await getDescuentosOptimized({
      page,
      ...(estadosGlobales ? { estados_globales: estadosGlobales } : {}),
      sujeto_tipo: sujeto,
      ...q,
    });
    setSelectedRowKeys([]);
    setSelectedData([]);
    setCurrentTableData([]);
    setTotalCount(_data?.count || 0);
    setData(formatReceivedClone(_data?.results || []));
    setLoading(false);
  };

  // "Exportar > Excel": el botón genérico de Table.jsx exporta lo que traiga `data`, que
  // ahora solo es la página visible (ver fetchData) -- exportaría datos incompletos sin
  // avisar. Este handler pide TODAS las filas del tab/sujeto activos ya armadas en Excel
  // por el servidor (ver exportarDescuentosEmpleadosVistaExcel), sin pasar por `data`.
  // No incluye la búsqueda por columna de Table.jsx (su estado es interno al componente).
  const onExportExcel = async () => {
    setLoading(true);
    const estadosGlobales = TAB_ESTADOS_DESCUENTOS[tabListaActiva];
    const blob = await exportarDescuentosEmpleadosExcel({
      ...(estadosGlobales ? { estados_globales: estadosGlobales } : {}),
      sujeto_tipo: sujetoActivo,
    });
    setLoading(false);
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Descuentos_de_Empleados.xlsx';
    link.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      try {
        await checkToken();
        const [
          _estados,
          _cuentasContables,
          // _areas,
          _empleados,
          _plazas,
          // _puestos,
          // _adminPlazas,
          _descuentos,
          _peridosDetalles,
          _tiposDescuentos,
          _datosOperacionales,
          _periodos,
          _tipos_de_nominas_empleados,
          _data,
        ] = await Promise.all([
          getEstadosGlobales(),
          getCuentasContables(),
          // getAreas(),
          getEmpleadosOptimized(),
          getPlazasvistaOptimized(),
          // getPuestos(),
          // getAdministracionDePlazasvistaOptimized(),
          getConfiguracionDescuentos({ content_type_model: SUJETO_EMPLEADO }),
          getPeriodosDeNominasDetalles(),
          getTiposDescuentos(),
          getDatoOperacionalesDeEmpleados(),
          getPeriodosDeNominas(),
          getTiposDeNominasEmpleados(),
          // getDescuentos(),
          // Carga inicial del tab "Todos": filtrada por sujeto Empleado (default),
          // solo la página 1 (ver fetchData) -- antes traía las ~80,000 filas de la
          // entidad completas en esta misma llamada.
          getDescuentosOptimized({ page: 1, sujeto_tipo: SUJETO_EMPLEADO }),
        ]);
        // const formattedURS = normalizeData(_areas);
        // const results = formatReceivedClone(_data.results);
        if (mounted) {
          setEstados(_estados);
          const normalized = normalize(_cuentasContables);
          setCuentasContables(normalized);
          // setAreas(formattedURS);
          setEmpleados(_empleados);
          setPersonasDataSource(_empleados);
          setPlazas(_plazas);
          // setPuestos(_puestos);
          // setAdminPlazas(_adminPlazas);
          setDescuentos(_descuentos);
          setPeriodosDetalles(_peridosDetalles.filter((periodosNomDetalle) => _periodos.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
          setTiposDescuentos(_tiposDescuentos);
          setDatosOperacionales(_datosOperacionales);
          setPeriodos(_periodos);
          setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
          setTotalCount(_data?.count || 0);
          setData(formatReceivedClone(_data?.results || []));
          setLoading(false);
        }
      } catch (err) {
        if (mounted) onError(err, setLoading);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisibleModal(false);
    setVisibleAuthorize(false);
    setVisibleCancelar(false);
    setVisibleReactivar(false);
    setVisibleInactivo(false);
    setVisibleSearch(false);
    setSelectedRowKeys([]);
    setSelectedData([]);
    setVisible(false);
    setPuesto();
    setArea();
    setPlaza();
    setMutable(true);
    setIsAutorizado(false);
    setIsInactivo(false);
    setIsCancelado(false);
    setEstadoActualRegistro();
    setSelectedTipoDescuento();
    setSelectedEmpleadoSearch();
    setSuspencionDefinitiva();
    setSuspencionTemporal();
    setIsBlocked(false);
    setNominaDisplay();
    form.resetFields();
    setCurrentTabKey('descuento');
  };

  const onClickEdit = async (responseData = null, directId = null) => {
    setLoading(true);

    const key = directId || selectedRowKeys[0];
    if (directId && !selectedRowKeys.includes(directId)) {
      setSelectedRowKeys([directId]);
    }
    const match = responseData || await getDescuento(key);
    const matchVista = data.find((e) => e.id === key) || {};

    if (!match) {
      message.warn(' No se encontró el descuento con el ID proporcionado');
      setLoading(false);
      return;
    }

    const tipoNominaId = matchVista.tipo_de_nomina_empleado || match.tipo_de_nomina_empleado;
    const tipoNominaObj = tiposDeNominaEmpleado.find((e) => e.id === tipoNominaId);

    setNominaDisplay(tipoNominaObj?.descripcion || 'Desconocido');

    if (tipoNominaObj?.habilitado) {
      setIsBlocked(false);
    } else {
      setIsBlocked(true);
    }

    form.setFieldsValue(match);

    //  Limpiar formularios
    form.resetFields();

    //  Determinar estado del descuento
    const esAutorizado = match.estados_globales === ESTATUS_AUTORIZADO;
    const esInactivo = match.estados_globales === ESTATUS_INACTIVO;
    setIsAutorizado(esAutorizado);
    setIsInactivo(esInactivo);
    setIsCancelado(match.estados_globales === ESTATUS_CANCELADO);
    setEstadoActualRegistro(match.estados_globales);

    //  Establecer valores en formularios principales
    form.setFieldsValue(formatReceivedClone(match));
    formExtra.setFieldsValue(formatReceivedClone(match));

    //  Persona: detectar sujeto, cargar personas y conceptos, setear ID en el Select
    let sujeto = SUJETO_EMPLEADO;
    let personaId = match.empleado;
    if (match.becario) {
      sujeto = SUJETO_BECARIO;
      personaId = match.becario;
    } else if (match.honorario_asimilado) {
      sujeto = SUJETO_HONORARIO_ASIMILADO;
      personaId = match.honorario_asimilado;
    }
    setSujetoActivo(sujeto);
    setSelectedEmpleadoSearch({ id: personaId });
    // Cargar personas del sujeto si cambió
    const fetchPersonas = GET_PERSONAS_POR_SUJETO[sujeto];
    if (fetchPersonas) {
      const personas = await fetchPersonas();
      setPersonasDataSource(personas);
    }
    // Recargar conceptos de descuento filtrados por sujeto
    const _descuentosSujeto = await getConfiguracionDescuentos({ content_type_model: sujeto });
    setDescuentos(_descuentosSujeto);
    form.setFieldValue('empleado', personaId);

    //  Datos visuales auxiliares
    setPuesto(matchVista.puesto_clave_y_descripcion || match.puesto_clave_y_descripcion || '');
    setArea(matchVista.directorio_de_area_clave_y_nombre || match.directorio_de_area_clave_y_nombre || '');
    setPlaza(matchVista.plaza_clave_y_descripcion || match.plaza_clave_y_descripcion || '');

    const tipoNominaInfo = tiposDeNominaEmpleado?.find(
      (t) => t.id === tipoNominaId,
    )?.descripcion || '';

    setTipoNominaEmpleadoInfo(tipoNominaInfo);

    //  Establecer periodo correspondiente al tipo de nómina del empleado
    setPeriodo(tipoNominaId);

    //  Buscar tipo de descuento relacionado
    const tipoDescuentoMatch = descuentos.find((e) => e.id === match.descuento);

    //  Normalizar el acreedor si viene como objeto (asegurar que sea solo el ID)
    if (tipoDescuentoMatch && typeof tipoDescuentoMatch.acreedor === 'object') {
      tipoDescuentoMatch.acreedor = tipoDescuentoMatch.acreedor?.id;
    }

    //  Establecer tipo de descuento y el ID asociado
    setSelectedTipoDescuento(tipoDescuentoMatch);
    setSelectedDescuento(match.descuento);

    //  Establecer estados de suspensión (si aplica)
    setSuspencionDefinitiva(match.es_suspencion_definitiva);
    setSuspencionTemporal(match.es_suspencion_temporal);

    //  Usar total_incapacidad o importe_pago si importe_base es 0 o nulo y viene de incidencia
    const importeDesdeIncidencia = match.total_incapacidad || match.importe_pago || 0;
    const importeBase = match.importe_base > 0
      ? match.importe_base
      : importeDesdeIncidencia;

    if (importeBase && !match.importe_base) {
      form.setFieldsValue({ importe_base: importeBase });
    }

    //  Si importe_fijo es 0/nulo, poblarlo con el total de la incidencia
    if (!match.importe_fijo && importeDesdeIncidencia > 0) {
      form.setFieldsValue({ importe_fijo: importeDesdeIncidencia });
    }

    //  Calcular importe por periodo si aplica
    if (match.no_de_periodos_de_descuento && importeBase > 0) {
      setImporteDescuento(
        (importeBase / match.no_de_periodos_de_descuento).toFixed(2),
      );
    } else {
      setImporteDescuento(importeBase.toFixed(2));
    }

    //  Estados globales del empleado (autorizado o inactivo)
    setDescuentoEmpleadoAutorizado(esAutorizado);
    setDescuentoEmpleadoInactivo(esInactivo);

    //  Abrir formulario
    setVisible(true);
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    // Evita guardar (p. ej. con Enter) un registro Cancelado.
    if (isCancelado) return;
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formExtra.getFieldsValue(),
      };
      // El form field 'empleado' contiene el nombre visual o el ID del Select;
      // eliminarlo y enviar el FK correcto según el tipo de sujeto activo.
      delete values.empleado;
      if (selectedEmpleadoSearch?.id) {
        values[SUJETO_FK[sujetoActivo]] = selectedEmpleadoSearch.id;
      }

      if (selectedRowKeys.length) {
        delete values.clave;
      }
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchDescuento(key, values) : postDescuento(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          setSelectedData([saved]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      message.warn('Favor de corregir los errores señalados');
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteDescuento(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const handleOnRowClick = async (record) => {
    let newSelectedRowKeys;
    let newSelectedData;

    if (selectedRowKeys.includes(record.id)) {
      newSelectedRowKeys = selectedRowKeys.filter((id) => id !== record.id);
      newSelectedData = selectedData.filter(
        (_selectedData) => _selectedData.id !== record.id,
      );
    } else {
      newSelectedRowKeys = [...selectedRowKeys, record.id];
      newSelectedData = [...selectedData, record];
    }

    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedData(newSelectedData);

    // setDisableFields(
    //   newSelectedRowKeys.length > 1
    //   || record?.estados_globales !== ESTATUS_ACTIVO,
    // );
  };

  const onChangeTabLista = (newTab) => {
    setTabListaActiva(newTab);
    setSelectedRowKeys([]);
    setSelectedData([]);
    setCurrentTableData([]);
    fetchData(1, null, newTab, sujetoActivo);
  };

  const onChangeSujeto = async (slug) => {
    setSujetoActivo(slug);
    setSelectedRowKeys([]);
    setSelectedData([]);
    setCurrentTableData([]);
    // Cargar personas del sujeto seleccionado para el Select del formulario
    const fetchPersonas = GET_PERSONAS_POR_SUJETO[slug];
    if (fetchPersonas) {
      const personas = await fetchPersonas();
      setPersonasDataSource(personas);
    }
    // Recargar conceptos de descuento filtrados por el sujeto seleccionado
    const _descuentos = await getConfiguracionDescuentos({ content_type_model: slug });
    setDescuentos(_descuentos);
    fetchData(1, null, tabListaActiva, slug);
  };

  const handleTableChange = (_pagination, _filters, _sorter, extra) => {
    setCurrentTableData(extra?.currentDataSource || []);
  };

  const effectiveData = currentTableData.length ? currentTableData : data;

  const rowSelection = {
    selectedRowKeys,
    type: 'checkbox',
    columnTitle: (
      <Checkbox
        checked={selectedRowKeys.length > 0 && selectedRowKeys.length === effectiveData.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < effectiveData.length}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedRowKeys(effectiveData.map((row) => row.id));
            setSelectedData([...effectiveData]);
          } else {
            setSelectedRowKeys([]);
            setSelectedData([]);
          }
        }}
      />
    ),
    onSelect: (record, selected) => {
      if (selected) {
        setSelectedRowKeys((prev) => [...prev, record.id]);
        setSelectedData((prev) => [...prev, record]);
      } else {
        setSelectedRowKeys((prev) => prev.filter((k) => k !== record.id));
        setSelectedData((prev) => prev.filter((row) => row.id !== record.id));
      }
    },
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedData(rows);
    },
  };

  const onClickAdd = () => {
    setDescuentoEmpleadoAutorizado(false);
    setDescuentoEmpleadoInactivo(false);
    onCancel();
    form.setFieldsValue({
      fecha_captura: moment(new Date().getDate(), 'DD/MM/YYYY'),
    });
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'nominas',
    contentTypeModel: 'descuentoempleado',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Descuentos Empleados',
    moduloOrigenLabel: 'Descuentos Empleados',
    registros: data,
    seleccionIds: selectedRowKeys,
    registroActivo: open && selectedRowKeys.length
      ? data.find((e) => e.id === selectedRowKeys[0]) || { id: selectedRowKeys[0] }
      : null,
    mutable: true,
    getRegistroLabel: (row) => `Descuento ${row.clave || row.id}`,
  });

  const columns = [
    {
      titleText: 'Folio',
      dataIndex: 'clave',
      key: 'clave',
      width: 120,
    },
    {
      titleText: 'Fecha de Asignación',
      dataIndex: 'fecha_de_asignacion',
      key: 'fecha_de_asignacion',
      width: 180,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Clave - Concepto de Descuento',
      dataIndex: 'clave_y_concepto',
      key: 'clave_y_concepto',
      width: 300,
      // render: (descuento_id) => {
      //   const descuento = descuentos?.find(
      //     (d) => d?.id === descuento_id,
      //   );

      //   return descuento?.clave_y_concepto || `ID ${descuento_id}`;
      // },
    },
    {
      titleText: 'Orden de Cálculo',
      dataIndex: 'orden_de_calculo',
      key: 'orden_de_calculo',
      width: 150,
      render: (val) => (val ?? ''),
    },
    {
      titleText: 'Tipo de Descuento',
      dataIndex: 'tipo_de_descuento_nombre',
      key: 'tipo_de_descuento_nombre',
      width: 220,
    },
    {
      titleText: `Número de ${SUJETO_ETIQUETA[sujetoActivo]}`,
      dataIndex: 'empleado_numero',
      key: 'empleado_numero',
      width: 160,
    },
    {
      titleText: 'Persona',
      dataIndex: 'empleado_numero_y_nombre_completo',
      key: 'persona_nombre',
      width: 280,
      render: (val, record) => record.becario_nombre || record.honorario_asimilado_nombre || val,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 260,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 260,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 300,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 220,
    },
    {
      titleText: `Tipo de ${SUJETO_ETIQUETA[sujetoActivo]}`,
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 220,
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 180,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 250,
      render: (val) => {
        const _periodo = periodosDetalles.find((e) => e.id === val);
        return _periodo ? `${_periodo.numero_de_nomina} (${_periodo.fecha_inicial} al ${_periodo.fecha_final})` : '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 160,
      // Tag con color por estatus (mismo criterio que Registro de Incidencias y
      // Asignación de Plazas). Se decide por el texto porque el Table a veces llama a
      // render sin el registro (ordenamiento).
      render: (descripcion) => {
        if (!descripcion) return null;
        const upper = String(descripcion).toUpperCase();
        let color = 'blue';
        if (upper.includes('AUTORIZ')) color = 'green';
        if (upper.includes('SUSPEND') || upper.includes('INACTIV')) color = 'orange';
        if (upper.includes('CANCEL')) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    nombre: [
      {
        pattern: NOMBRES_PATTERN,
        message: 'ingrese un nombre válido',
      },
    ],
  };

  const nameEmpleado = 'empleado';
  const getPlaza = (idEmpleado) => {
    const _datoOperacional = datosOperacionales?.find((e) => e.empleado === idEmpleado);
    const idPlaza = _datoOperacional?.plaza;
    return ({
      _plaza: plazas?.find((p) => p.id === idPlaza),
      _datoOp: _datoOperacional,
    });
  };
  const onChangeEmpleado = async (empleadoId) => {
    if (!empleadoId) {
      setSelectedEmpleadoSearch();
      form.setFieldsValue({ plaza: '', puesto: '', area: '' });
      setPlaza('');
      setArea('');
      setPuesto('');
      setTipoNominaEmpleadoInfo('');
      setPeriodo(null);
      return;
    }

    // Sin esto, onFinish nunca encuentra un id limpio que enviar (el campo
    // 'empleado' del Form puede traer el texto visual, no el id) y el
    // backend rechaza con "Debe indicar exactamente uno de: empleado,
    // becario u honorario asimilado" -- ver mismo fix ya aplicado en
    // onClickEdit (arriba) y en IncidenciasEmpleados.jsx.
    setSelectedEmpleadoSearch({ id: empleadoId });

    // Intentar resolución local (solo funciona para empleados precargados)
    let _datoOp = datosOperacionales?.find((e) => e.empleado === empleadoId);

    // Si no se encontró localmente, buscar vía API según el tipo de sujeto
    if (!_datoOp) {
      const fetchDatoOp = GET_DATO_OP_POR_SUJETO[sujetoActivo];
      if (fetchDatoOp) {
        _datoOp = await fetchDatoOp(empleadoId);
      }
    }

    const idPlaza = _datoOp?.plaza;
    const _plaza = plazas?.find((p) => p.id === idPlaza);

    const tipoNominaInfo = _plaza?.tipo_nomina_empleado || '';
    const areaStr = _plaza?.directorio_area_clave_y_nombre || '';
    const plazaStr = _plaza?.clave_y_descripcion || '';
    const puestoStr = _plaza?.puesto_descripcion || '';
    const tipoNomina = _datoOp?.tipo_de_nomina_empleado || null;

    form.setFieldsValue({ plaza: plazaStr, puesto: puestoStr, area: areaStr });

    setPlaza(plazaStr);
    setArea(areaStr);
    setPuesto(puestoStr);
    setTipoNominaEmpleadoInfo(tipoNominaInfo);
    setPeriodo(tipoNomina);
  };

  // const onChangeEmpleado = async (val) => {
  //   if (val) {
  //     try {
  //       // Obtener empleado por ID
  //       const _empleado = await getEmpleado(val);

  //       // Obtener datos operacionales del empleado
  //       const [_datosOperacionales] = await getDatoOperacionalesDeEmpleados({ empleado: val });

  //       // Buscar plaza asociada
  //       const _plaza = plazas?.find((p) => p.id === _datosOperacionales?.plaza);

  //       // Obtener puesto completo
  //       let _puestoCompleto = null;
  //       if (_plaza?.puesto_id) {
  //         _puestoCompleto = await getPuesto(_plaza.puesto_id);
  //       }

  //       // Construir strings de texto
  //       const nombreCompleto = _empleado?.numero_y_nombre_completo
  //         ? _empleado.numero_y_nombre_completo
  //         : `${_empleado?.numero_de_empleado} - ${_empleado?.nombre} ${_empleado?.apellido_paterno} ${_empleado?.apellido_materno}`;

  //       const areaStr = _plaza?.directorio_area_clave_y_nombre || '';
  //       const plazaStr = _plaza?.clave_y_descripcion || '';
  //       const puestoStr = _puestoCompleto
  //         ? `${_puestoCompleto?.clave} - ${_puestoCompleto?.descripcion}`
  //         : _plaza?.puesto_descripcion || '';

  //       const tipoNominaInfo = _plaza?.tipo_nomina_empleado || '';

  //       // Actualizar campos del formulario principal
  //       form.setFieldsValue({
  //         empleado: nombreCompleto,
  //         plaza: plazaStr,
  //         puesto: puestoStr,
  //         area: areaStr,
  //       });

  //       // Actualizar estados locales
  //       setSelectedEmpleadoSearch(_empleado);
  //       setPlaza(plazaStr);
  //       setArea(areaStr);
  //       setPuesto(puestoStr);
  //       setTipoNominaEmpleadoInfo(tipoNominaInfo);

  //       // Actualizar tipo de nómina (si aplica)
  //       setPeriodo(_datosOperacionales?.tipo_de_nomina_empleado || null);
  //     } catch (error) {
  //       onError(error);
  //     }
  //   } else {
  //     form.resetFields(['empleado', 'plaza', 'puesto', 'area']);
  //     setSelectedEmpleadoSearch();
  //     setPlaza();
  //     setPuesto();
  //     setArea();
  //     setTipoNominaEmpleadoInfo();
  //   }
  // };

  // const validateInput = async () => {
  //   setLoading(true);
  //   setSelectedEmpleadoSearch();
  //   const searchEmp = form.getFieldValue('empleado');
  //   if (!searchEmp) {
  //     setVisibleSearch(true);
  //     return setLoading(false);
  //   }
  //   const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`);
  //   const result = res?.results[0];
  //   if (!res) {
  //     return setLoading(false);
  //   }
  //   const empleadoResult = result?.empleado;
  //   setSelectedEmpleadoSearch(empleadoResult);
  //   if (empleadoResult) {
  //     form.setFieldsValue({
  //       empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
  //     });
  //   } else {
  //     form.resetFields(['empleado']);
  //   }
  //   onChangeEmpleado(empleadoResult?.id);
  //   return setLoading(false);
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURIDatosOpPaginado);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
  //   setDataSearch(_empleados);
  //   return setLoading(false);
  // };

  // const columnsEmpleado = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     render: (empObject) => {
  //       const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
  //       const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
  //       const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
  //       return `${puestoEmp?.descripcion || ''}`;
  //     },
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const templateHeaders = [{
        'Num EMP': '',
        'Clave Descuento': '',
        'Fecha Asignación (YYYY-MM-DD)': '',
        'Fecha Inicio (YYYY-MM-DD)': '',
        'Fecha Termino (YYYY-MM-DD)': '',
        'Importe Credito': '',
        'Saldo Actual': '',
        'Acumulado Actual': '',
        'Numero de Pagos': '',
        'Importe Pago': '',
        'Porcentaje de Pago': '',
        Observaciones: '',
        'Cuenta Contable': '',
        'No. de Oficio': '',
        'Fecha del Oficio (YYYY-MM-DD)': '',
        'Nombre del Juzgado': '',
        'Nombre del Juez': '',
        'Periodo de Nómina': '',
      }];
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(templateHeaders);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla');

      const currentYear = new Date().getFullYear();
      const periodosRaw = await getPeriodosDeNominasDetalles();
      const periodosMapped = (periodosRaw || [])
        .filter((p) => p.fecha_inicial && p.fecha_inicial.startsWith(String(currentYear)))
        .map((p) => ({
          'Periodo de Nómina': `${p.numero_de_nomina} (${p.fecha_inicial} al ${p.fecha_final})`,
        }));
      const wsPeriodos = XLSX.utils.json_to_sheet(
        periodosMapped.length
          ? periodosMapped
          : [{ 'Periodo de Nómina': '' }],
      );
      XLSX.utils.book_append_sheet(workbook, wsPeriodos, 'Periodos de Nómina');

      const descuentosResp = await API.get('nominas/descuentos/', { params: { estados_globales: 4 } });
      const descuentosData = Array.isArray(descuentosResp.data)
        ? descuentosResp.data
        : (descuentosResp.data?.results || []);
      const descuentosMapped = descuentosData.map((d) => ({ Clave: d.clave, Concepto: d.concepto }));
      const wsDescuentos = XLSX.utils.json_to_sheet(
        descuentosMapped.length ? descuentosMapped : [{ Clave: '', Concepto: '' }],
      );
      XLSX.utils.book_append_sheet(workbook, wsDescuentos, 'Descuentos');

      XLSX.writeFile(workbook, 'Descuentos_Plantilla.xlsx');
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  useEffect(() => {
    if (!isPollingImport) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingImportRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImport({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportRef.current);
          pollingImportRef.current = null;
          setIsPollingImport(false);
          setProgresoImport({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Descuentos_Importacion.xlsx';
            link.click();
            URL.revokeObjectURL(url);
            notification.success({
              message: 'Importación completada',
              description: 'La carga masiva de descuentos finalizó. Se descargó el archivo de resultado.',
              placement: 'topRight',
              duration: 6,
            });
          } else {
            notification.error({
              message: 'Error en la importación',
              description: 'La tarea no generó resultado. Reinicia el worker de Celery y vuelve a intentarlo.',
              placement: 'topRight',
              duration: 10,
            });
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación de descuentos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportRef.current) {
        clearInterval(pollingImportRef.current);
        pollingImportRef.current = null;
      }
    };
  }, [isPollingImport]);

  useEffect(() => {
    if (!isPollingCambioEstados) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingCambioEstadosRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_CAMBIO_ESTADOS,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoCambioEstados({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingCambioEstadosRef.current);
          pollingCambioEstadosRef.current = null;
          setIsPollingCambioEstados(false);
          setProgresoCambioEstados({ en_curso: 0, total: 0 });
          setVisibleCancelar(false);
          setVisibleReactivar(false);
          setVisibleAuthorize(false);
          setSelectedRowKeys([]);
          setSelectedData([]);

          if (proceso?.resultado) {
            try {
              const resultado = JSON.parse(proceso.resultado);
              if (resultado.errores && resultado.errores.length > 0) {
                notification.warning({
                  message: 'Proceso completado con errores',
                  description: resultado.errores.slice(0, 5).join(' | '),
                  placement: 'topRight',
                  duration: 12,
                });
              } else {
                notification.success({
                  message: 'Operación completada',
                  description: 'El cambio de estado de los descuentos finalizó correctamente.',
                  placement: 'topRight',
                  duration: 6,
                });
              }
            } catch (_e) {
              notification.success({ message: 'Operación completada', duration: 6 });
            }
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling cambio de estados de descuentos] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingCambioEstadosRef.current) {
        clearInterval(pollingCambioEstadosRef.current);
        pollingCambioEstadosRef.current = null;
      }
    };
  }, [isPollingCambioEstados]);

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await API.post(uri, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response?.status === 202) {
          setVisibleModal(false);
          formCarga.resetFields();
          setIsPollingImport(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const shouldRenderTab = (descuentoSelected) => {
  //   const { requiere_beneficiarios_externos, requiere_datos_informativos, tipo_de_descuento } = descuentoSelected || {};
  //   const isTipoDescuentoValid = tipo_de_descuento === DESCUENTO_RECURRENTE_Y_VARIABLE || tipo_de_descuento === DESCUENTO_RECURRENTE_Y_FIJO || tipo_de_descuento === DESCUENTO_TEMPORAL;
  //   const renderTabInformativos = requiere_datos_informativos && isTipoDescuentoValid && selectedTipoDescuento?.tipo_de_descuento;
  //   const renderTabExternos = requiere_beneficiarios_externos && isTipoDescuentoValid && selectedTipoDescuento?.tipo_de_descuento;
  //   return { renderTabInformativos, renderTabExternos };
  // };

  useEffect(() => {
    // Si selectedEmpleadoSearch tiene datos personales, construye el nombre
    if (
      selectedEmpleadoSearch?.numero_de_empleado
      && selectedEmpleadoSearch?.nombre
      && selectedEmpleadoSearch?.apellido_paterno
    ) {
      const nombreCompleto = `${selectedEmpleadoSearch.numero_de_empleado} - ${selectedEmpleadoSearch.nombre} ${selectedEmpleadoSearch.apellido_paterno} ${selectedEmpleadoSearch.apellido_materno || ''}`;
      form.setFieldValue('empleado', nombreCompleto.trim());
    }
  }, [selectedEmpleadoSearch]);

  const ModalForAutorizar = () => {
    const onConfirmAutorizar = async () => {
      try {
        setLoading(true);
        const ids = selectedRowKeys.map((id) => ({ id }));
        const response = await API.put(
          `/nominas/cambiar-estados-descuentos-empleados/${ESTATUS_AUTORIZADO}/`,
          ids,
        );
        if (response?.status === 202) {
          setVisibleAuthorize(false);
          setIsPollingCambioEstados(true);
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalConfirmation
        onFinish={onConfirmAutorizar}
        ConfirmAutorize
        onCancel={() => setVisibleAuthorize(false)}
        contentTitle="Autorizar Registros"
        open={visibleAuthorize}
        loading={loading}
        extraContent={(
          <span style={{
            display: 'block',
            textAlign: 'right',
            marginTop: 16,
            color: '#262626',
            fontSize: 15,
            fontWeight: 600,
          }}
          >
            {`Registros seleccionados: ${selectedRowKeys.length}`}
          </span>
        )}
      />
    );
  };
  const ModalCancelar = () => {
    const onConfirmCancelar = async () => {
      try {
        setLoading(true);
        const ids = selectedRowKeys.map((id) => ({ id }));
        const response = await API.put(
          `/nominas/cambiar-estados-descuentos-empleados/${ESTATUS_CANCELADO}/`,
          ids,
        );
        if (response?.status === 202) {
          setVisibleCancelar(false);
          setIsPollingCambioEstados(true);
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalConfirmation
        onFinish={onConfirmCancelar}
        ConfirmCancel
        onCancel={() => { setVisibleCancelar(false); }}
        open={visibleCancelar}
        contentTitle={`Cancelar ${selectedRowKeys.length} descuento(s) seleccionado(s)`}
        loading={loading}
      />
    );
  };
  const ModalReactivar = () => {
    const onConfirmReactivar = async () => {
      try {
        setLoading(true);
        const ids = selectedRowKeys.map((id) => ({ id }));
        const response = await API.put(
          `/nominas/cambiar-estados-descuentos-empleados/${ESTATUS_ACTIVO}/`,
          ids,
        );
        if (response?.status === 202) {
          setVisibleReactivar(false);
          setIsPollingCambioEstados(true);
        }
        setLoading(false);
      } catch (err) {
        onError(err, setLoading);
      }
    };
    return (
      <ModalConfirmation
        onFinish={onConfirmReactivar}
        onFinishText="Reactivar"
        onFinishIcon={<RedoOutlined />}
        onCancel={() => { setVisibleReactivar(false); }}
        contentTitle="Reactivar Descuento"
        open={visibleReactivar}
        loading={loading}
        extraContent={(
          <span style={{
            display: 'block',
            textAlign: 'right',
            marginTop: 16,
            color: '#262626',
            fontSize: 15,
            fontWeight: 600,
          }}
          >
            {`Registros seleccionados: ${selectedRowKeys.length}`}
          </span>
        )}
      />
    );
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  // Inactivos y Cancelados se muestran en solo lectura: sin Guardar, Agregar ni Eliminar.
  const esSoloLectura = isInactivo || isCancelado;

  const getControls = () => {
    if (isBlocked) {
      return {
        onClickAdd,
        onClickEdit: (record) => onClickEdit(null, record?.id || null),
        onClickDelete: () => onAlert(`El Tipo de Nómina Empleado ${nominaDisplay} se encuentra cerrado`),
      };
    }
    return {
      onClickAdd,
      onClickEdit: (record) => onClickEdit(null, record?.id || null),
      onClickDelete,
    };
  };

  // ── Acciones por estatus ──────────────────────────────────────────────
  // Cada acción se habilita solo si TODOS los registros seleccionados están en un
  // estatus válido para ella. Los tabs por estatus muestran solo sus acciones; el tab
  // "Todos" muestra todas y el estatus decide cuál aplica.
  const seleccionEnEstados = (estadosPermitidos) => selectedData.length > 0
    && selectedData.every((row) => estadosPermitidos.includes(row.estados_globales));

  const accionAutorizar = {
    onClick: () => setVisibleAuthorize(true),
    permission: { model: 'descuento', action: 'autorizar' },
    icon: <CheckCircleOutlined />,
    text: 'Autorizar',
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO]),
    className: 'success',
  };

  const accionCancelar = {
    permission: { model: 'descuento', action: 'cancelar' },
    onClick: () => setVisibleCancelar(true),
    icon: <CloseCircleOutlined />,
    text: 'Cancelar',
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]),
    className: 'cancel',
  };

  const accionReactivar = {
    permission: { model: 'descuentoempleado', action: 'reactivar' },
    onClick: () => setVisibleReactivar(true),
    icon: <RedoOutlined />,
    text: 'Reactivar',
    disabledBySelection: true,
    disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]),
    className: 'success',
  };

  const renderTablaDescuentos = ({ customActions = [], disableDelete }) => (
    seguimiento.conBarra(<Table
      cols={[seguimiento.columnaSeguimiento, ...columns]}
      data={data}
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      allowCustomImport
      customImportMenu={menuImport}
      customImportText="Importar Descuentos"
      allowImport
      baseURI={baseURI}
      // Importar y Autorizar/Cancelar/Reactivar agrupados en menús para que la barra
      // no le quite alto a la tabla (igual que Registro de Incidencias).
      groupImports
      groupImportsText="Importar"
      customActionsDropdown
      customActionsDropdownText="Acciones"
      controls={getControls()}
      onTableChange={handleTableChange}
      customActions={[...(customActions || []), seguimiento.accionSeguimiento]}
      disableDelete={disableDelete}
      permission={permission}
      allowExportPDF={false}
      // Paginado en servidor (ver fetchData/getDescuentosEmpleadosVistaOptimized):
      // `data` trae solo la página actual, `count` el total real que coincide con el
      // tab/sujeto/búsqueda activos. `q` es la búsqueda por columna que arma Table.jsx
      // (Table.jsx ya resetea a la página 1 al buscar); el tab/sujeto los toma fetchData
      // de su propio estado (closure), así que aquí solo se reenvían page y q.
      pagination={false}
      paginationCallback={(page, q) => fetchData(page, q)}
      count={totalCount}
      // Reemplaza el "Excel" genérico (exportaría solo la página visible, ver
      // onExportExcel) -- pide todas las filas del tab/sujeto activos ya armadas en
      // Excel por el servidor.
      onExportExcel={onExportExcel}
      extraExportItems={[{
        key: 'reporte_descuentos',
        label: 'Reporte de Descuentos',
        icon: <FileExcelOutlined />,
        onClick: () => setShowReporteDescuentos(true),
      }]}
    />)
  );

  return (
    // `container` + Card `tables-container` (sin Card anidado por tab) para que la tabla
    // se ajuste al alto de la ventana, igual que Registro de Incidencias.
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card bordered={false} className="tables-container">
          <Row style={{ marginBottom: 12 }}>
            <Col>
              <span style={{ marginRight: 8, fontWeight: 500 }}>Tipo de Sujeto:</span>
              <AntSelect
                value={sujetoActivo}
                onChange={onChangeSujeto}
                style={{ width: 220 }}
                options={SUJETO_OPCIONES.map((s) => ({ value: s.slug, label: s.etiqueta }))}
              />
            </Col>
          </Row>
          <Tabs
            activeKey={tabListaActiva}
            onChange={onChangeTabLista}
            items={[
              {
                key: 'todos',
                label: 'Todos',
                children: renderTablaDescuentos({
                  customActions: [accionAutorizar, accionCancelar, accionReactivar],
                  // Eliminar solo aplica a descuentos Activos
                  disableDelete: !seleccionEnEstados([ESTATUS_ACTIVO]),
                }),
              },
              {
                key: 'activas',
                label: 'Activos',
                children: renderTablaDescuentos({
                  customActions: [accionAutorizar, accionCancelar],
                  disableDelete: selectedData[0]?.estados_globales === ESTATUS_AUTORIZADO,
                }),
              },
              {
                key: 'autorizadas',
                label: 'Autorizados',
                children: renderTablaDescuentos({
                  customActions: [accionCancelar, accionReactivar],
                  disableDelete: true,
                }),
              },
              {
                key: 'canceladas',
                label: 'Cancelados',
                children: renderTablaDescuentos({
                  customActions: [accionReactivar],
                  disableDelete: true,
                }),
              },
              {
                key: 'suspendidos',
                label: 'Suspendidos',
                children: renderTablaDescuentos({ disableDelete: true }),
              },
            ]}
          />
        </Card>
        <Modal
          open={open}
          closable={false}
          cancelButtonProps={{ style: { display: 'none' } }}
          okButtonProps={{ style: { display: 'none' } }}
          width="85%"
        >
          <Card
            className="form-container"
            title={(
              <FormSubmitControls
                label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Descuento de ${SUJETO_ETIQUETA[sujetoActivo]}`}
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                allowSave={!esSoloLectura}
                mutable={!isCancelado}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                scrollToFirstError
                name="general"
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="clave"
                      label="Clave"
                      hasFeedback
                    >
                      <Input
                        allowClear
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_asignacion"
                      label="Fecha de Asignación"
                      rules={rules.required}
                    >
                      <DatePicker
                        allowClear
                        format="DD/MM/YYYY"
                        disabled={isAutorizado || esSoloLectura || isBlocked}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name={nameEmpleado}
                      label={SUJETO_LABEL_PERSONA[sujetoActivo]}
                      required
                      hasFeedback
                    >
                      <Select
                        labelProp={SUJETO_LABEL_PROP[sujetoActivo]}
                        dataSource={personasDataSource}
                        onChange={onChangeEmpleado}
                        disabled={!!selectedRowKeys?.length}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Puesto"
                    >
                      <Input
                        allowClear
                        disabled
                        value={puesto}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Área"
                    >
                      <Input
                        allowClear
                        disabled
                        value={area}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Plaza"
                      hasFeedback
                    >
                      <Input
                        allowClear
                        disabled
                        value={plaza}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="descuento"
                      label="Concepto de Descuento"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        keyProp="clave"
                        labelProp="concepto"
                        keyLabelRender
                        dataSource={descuentos}
                        onChange={(value) => {
                          setSelectedTipoDescuento(descuentos.find((e) => e.id === value));
                          form.resetFields(['porcentaje_de_descuento']);
                        }}
                        disabled={!!selectedRowKeys.length}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Tipo de Nómina de Empleado"
                      help={!tipoNominaEmpleadoInfo ? `El ${SUJETO_ETIQUETA[sujetoActivo].toLowerCase()} no tiene Plaza asignada, seleccione manualmente` : undefined}
                    >
                      {tipoNominaEmpleadoInfo ? (
                        <Input
                          allowClear
                          disabled
                          value={tipoNominaEmpleadoInfo}
                        />
                      ) : (
                        <Select
                          dataSource={tiposDeNominaEmpleado.filter(
                            (t) => t.content_type_model === sujetoActivo,
                          )}
                          value={periodo}
                          disabled={isAutorizado || esSoloLectura || isBlocked}
                          onChange={(value) => {
                            setPeriodo(value);
                            form.resetFields(['periodo_de_nomina_detalle']);
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  {selectedRowKeys.length
                    ? (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          hasFeedback
                        >
                          <Select
                            dataSource={estados}
                            activeInactive={estadoActualRegistro === ESTATUS_ACTIVO
                            || estadoActualRegistro === ESTATUS_INACTIVO}
                            onChange={(val) => setVisibleInactivo(val === ESTATUS_INACTIVO)}
                            disabled={isAutorizado || esSoloLectura || isBlocked}
                          />
                        </Form.Item>
                      </Col>
                    )
                    : (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          hasFeedback
                          initialValue={1}
                        >
                          <Select
                            dataSource={estados}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    )}
                  {/* {selectedTipoDescuento?.aplica_cuenta_contable_del_empleado
                  ? (
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="cuenta_contable"
                        label="Cuenta Contable"
                        rules={[{ required: true, message: 'Selecciona una cuenta contable' }]}
                        hasFeedback
                      >
                        <TreeSelect
                          showSearch
                          allowClear
                          treeNodeFilterProp="title"
                          // treeDefaultExpandAll
                          style={{ width: '100%' }}
                          treeData={mapToTreeData(cuentasContables)}
                        />
                      </Form.Item>
                    </Col>
                  ) : null} */}
                </Row>
                <Tabs
                  activeKey={currentTabKey}
                  onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                  type="card"
                  style={{ overflow: 'hidden !important' }}
                >
                  <TabPane
                    tab="Descuento"
                    key="descuento"
                    forceRender
                  >
                    <TipoDescuento
                      form={form}
                      selectedRowKeys={selectedRowKeys}
                      selectedDescuento={selectedDescuento}
                      tipoDescuento={selectedTipoDescuento}
                      importeDescuento={importeDescuento}
                      setImporteDescuento={setImporteDescuento}
                      descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoAutorizado
                      || descuentoEmpleadoInactivo}
                      disableFields={isAutorizado || esSoloLectura}
                      periodo={periodo}
                      periodosNominasDetalles={periodosDetalles}
                      isBlocked={isBlocked}
                      onFinish={onFinish}
                    />
                  </TabPane>
                  <TabPane
                    tab="Datos Informativos"
                    key="datos"
                    forceRender
                  >
                    {/* { shouldRenderTab(selectedTipoDescuento).renderTabInformativos

                    ? ( */}
                    <DatosInformativos
                      form={formExtra}
                      rules={rules}
                      disabled={esSoloLectura}
                      isBlocked={isBlocked}
                    />
                    {/* // ) : null} */}
                  </TabPane>
                  <TabPane
                    tab="Beneficiarios Externos"
                    key="beneficiarios"
                    forceRender
                  >
                    {/* { shouldRenderTab(selectedTipoDescuento).renderTabExternos
                    ? ( */}
                    <BeneficiariosExternos
                      disable={isAutorizado || esSoloLectura}
                      permissions={getPermission}
                      selected={selectedRowKeys[0]}
                      isBlocked={isBlocked}
                    />
                    {/* ) : null} */}
                  </TabPane>
                  <TabPane
                    tab="Suspensión"
                    key="suspencion"
                    forceRender
                  >
                    {selectedTipoDescuento?.tipo_de_descuento !== agrupadorDescuentos[2].id && selectedTipoDescuento?.tipo_de_descuento
                      ? (
                        <DescuentoSuspencion
                          form={formExtra}
                          rules={rules}
                          disableFields={esSoloLectura}
                          periodosNominasDetalles={periodosDetalles.filter((d) => periodos.find((p) => p.id === d.periodo_de_nomina)?.tipo_de_nomina_empleado === periodo)}
                          suspencionDefinitiva={suspencionDefinitiva}
                          setSuspencionDefinitiva={setSuspencionDefinitiva}
                          suspencionTemporal={suspencionTemporal}
                          setSuspencionTemporal={setSuspencionTemporal}
                          isBlocked={isBlocked}
                        />
                      ) : null}
                  </TabPane>
                  <TabPane
                    tab="Adjuntos"
                    key="adjuntos"
                    forceRender
                  >
                    <Adjuntos
                      disable={isAutorizado || esSoloLectura}
                      permissions={getPermission}
                      selected={selectedRowKeys[0]}
                      isBlocked={isBlocked}
                    />
                  </TabPane>
                </Tabs>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>,
              'este Descuento',
            )}
          </Card>
        </Modal>
        {seguimiento.modalSeguimiento}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Descuento de ${SUJETO_ETIQUETA[sujetoActivo]}`}
          loading={loading}
        />
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
        <ModalCancelar />
        <ModalForAutorizar />
        <ModalReactivar />
        <Modal
          open={isPollingImport}
          title="Importando Descuentos..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoImport.total > 0
                  ? Math.round((progresoImport.en_curso / progresoImport.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoImport.en_curso}
              {' / '}
              {progresoImport.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        <Modal
          open={isPollingCambioEstados}
          title="Procesando..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoCambioEstados.total > 0
                  ? Math.round((progresoCambioEstados.en_curso / progresoCambioEstados.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoCambioEstados.en_curso}
              {' / '}
              {progresoCambioEstados.total}
              {' registros procesados'}
            </p>
          </div>
        </Modal>
        {/* <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={(row) => {
            setSelectedEmpleadoSearch(row);
            onChangeEmpleado(row);
          }}
        /> */}
        <ReporteRecurrenteModal
          open={showReporteDescuentos}
          onClose={() => setShowReporteDescuentos(false)}
          tipo="descuentos"
          titulo="Reporte de Descuentos"
          conceptoLabel="Conceptos de Descuento"
          conceptos={(descuentos || []).map((d) => ({ id: d.id, label: `${d.clave} - ${d.concepto}` }))}
          columnasConcepto={[
            { header: 'Concepto', key: 'concepto', width: 34 },
            { header: 'Folio Descuento', key: 'folio_descuento', width: 16 },
            { header: 'Parcialidad', key: 'parcialidad', width: 12 },
            { header: 'Acreedor', key: 'acreedor', width: 34 },
            {
              header: 'Importe', key: 'importe', width: 15, numFmt: FORMATO_MONEDA,
            },
            {
              header: 'Saldo Restante', key: 'saldo_restante', width: 15, numFmt: FORMATO_MONEDA,
            },
          ]}
          fileName="Reporte_Descuentos"
        />
      </Spin>
    </Row>
  );
};

export default Descuento;
